<template>
	<!-- HAP-5052: a Register button's label, swapped for a spinner + "Starting…" while
	     SelectEvents is starting a registration (store.registrationStarting). -->
	<span v-if="store?.registrationStarting" class="inline-flex items-center justify-center whitespace-nowrap" aria-live="polite">
		<Spinner class="w-4 h-4 inline-block mr-2" :small="true" color="border-t-current" />
		Starting…
	</span>
	<slot v-else />
</template>

<script>
export default {
	name: 'RegisterLabel',
	inject: { store: { default: null } },
}
</script>
